var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M5.5 7.084l.258 1.254.398 1.268.71 1.306L8.122 12l1.485.773 1.41.478h1.938l1.22-.478L15.759 12l.959-.87.89-1.084.415-1.408V7.473l.203-.39v-.415L5.5 6.863z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.814 3.07a.213.213 0 00-.207.207v2.215c0 .11.096.207.207.207.111 0 .208-.096.208-.207V3.277a.213.213 0 00-.208-.208zm2.077.691a.213.213 0 00-.208.208v1.523c0 .11.097.207.208.207.11 0 .207-.096.207-.207V3.969a.213.213 0 00-.207-.208zm2.076.693a.213.213 0 00-.207.207v.83c0 .112.096.208.207.208.111 0 .208-.096.208-.207v-.83a.213.213 0 00-.208-.208zm-9.69 2.214a.213.213 0 00-.208.208c0 .11.097.208.208.208h1.066a6.553 6.553 0 003.516 5.593l-3.378 6.838c-.055.097-.014.222.097.277a.2.2 0 00.097.028c.083 0 .152-.042.18-.111l1.841-3.71h8.583l.443.927c-.415.291-.692.776-.692 1.315 0 .873.72 1.592 1.592 1.592.872 0 1.592-.72 1.592-1.592 0-.872-.72-1.592-1.592-1.592-.18 0-.36.028-.526.098l-1.994-4.168c1.938-1.093 3.268-3.142 3.337-5.495h1.066c.11 0 .207-.097.207-.208a.213.213 0 00-.207-.208H4.277zm1.481.416h.969a5.169 5.169 0 005.164 4.956c.11 0 .207-.097.207-.208a.213.213 0 00-.207-.207 4.762 4.762 0 01-4.749-4.541h10.881a6.14 6.14 0 01-6.132 5.925c-3.309 0-6.022-2.644-6.133-5.925zm8.984 5.69l1.33 2.796H7.89l1.343-2.714c.817.36 1.716.568 2.658.568a6.58 6.58 0 002.851-.65zm2.866 4.277a1.176 1.176 0 110 2.353 1.176 1.176 0 110-2.353z",
    fill: "#666",
    fillRule: "nonzero",
    stroke: "#666",
    strokeWidth: 0.4
  }))));
}
export default SvgKitchen;